<script lang="ts">
    
    import type { Game } from "../../Model/Game";
    import type { Player } from "../../Model/Player";
    import PlayerDisplay from "../Monitor/PlayerDisplay.svelte";
    import { GameTypeService } from "../../Services/GameTypeService";

    export let player: Player;
    export let game: Game;

    $: winImage = GameTypeService.getWinImage(game.type);

</script>

<div class="win">
    <div class="content">
        <img class="logo" src={winImage} alt="BinFun">
        <PlayerDisplay {player} {game} />
    </div>
</div>

<style lang="scss">

    .win {
        display: flex;
        justify-content: center;
    }

    .content {
        width: calc(100% - 2rem);
        max-width: 600px;
    }

    .logo {
        width: 100%;
        animation: logo 0.6s ease;
    }

    @keyframes logo {
        0% {
            transform: scale(0) rotate(0deg) translateY(-1vh);
        }
        33% {
            transform: scale(1.2) rotate(10deg) translateY(2vh);
        }
        66% {
            transform: scale(0.9) rotate(-10deg) translateY(-0.5vh);
        }
        100% {
            transform: scale(1) rotate(0deg) translateY(0);
        }
    }

    @keyframes picture {
        from {
            transform: scale(0);
        }
        to {
            transform: scale(1);
        }
    }

    @keyframes name {
        from {
            transform: scaleX(0);
        }
        to {
            transform: scaleX(1);
        }
    }

</style>
